<h1 mat-dialog-title i18n="@@validation-result-dialog.title">Validation results</h1>
<div mat-dialog-content>
  <table mat-table [dataSource]="validationError">

    <ng-container matColumnDef="severity">
      <th mat-header-cell *matHeaderCellDef i18n="@@validation-result-dialog.table-title.severity">Type</th>
      <td mat-cell *matCellDef="let error">
        <mat-icon [svgIcon]="error.severity"></mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="stepName">
      <th mat-header-cell *matHeaderCellDef i18n="@@validation-result-dialog.table-title.stepName">Step</th>
      <td mat-cell *matCellDef="let error"> {{error.stepName}} </td>
    </ng-container>


    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef i18n="@@validation-result-dialog.table-title.code">Code</th>
      <td mat-cell *matCellDef="let error"> {{error.code}} </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef i18n="@@validation-result-dialog.table-title.description">Description</th>
      <td mat-cell *matCellDef="let error"> {{error.message}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['severity', 'stepName', 'code', 'description']; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: ['severity', 'stepName', 'code', 'description'];"></tr>
  </table>
</div>
<div mat-dialog-actions>
  <button mat-button color="primary" mat-dialog-close cdkFocusInitial i18n="@@validation-result-dialog.button.ok">Ok</button>
</div>
